import { flatProductList } from '../utils';

/**
 *
 * @param group
 * @param tiered: if true, sub groups will be rendered. else, any products under sub groups will be children of @group
 * @param renderGroupFn
 * @param renderProductFn
 * @returns {*}
 * @constructor
 */
const ProductGroup = ({
  group,
  tiered = false,
  renderGroupFn,
  renderProductFn,
}) => {
  const renderGroup = (group, tiered) => {
    let products = [];
    let subGroups = [];

    if (
      Object.prototype.hasOwnProperty.call(group, 'groups') &&
      group.groups.length
    ) {
      subGroups = tiered
        ? group.groups.map((subGroup) => renderGroup(subGroup, tiered))
        : [];
    }

    const productList = tiered ? group.products || [] : flatProductList(group);
    if (productList.length) {
      products = productList.map((p) => renderProductFn(p));
    }

    return renderGroupFn(group, subGroups, products);
  };

  return renderGroup(group, tiered);
};

export default ProductGroup;
